/// <amd-module name="Search/WorkItem/Flux/Stores/SearchStore" />
import * as Utils from "Search/WorkItem/Utils";
import * as BaseSearchStore from "Search/Shared/Base/Stores/SearchStore";
import { ISortOptionChangedPayload } from "Search/Shared/Base/ActionsHub";
import { ISeedData } from "Search/Shared/Base/Types";
import { WorkItemResult, WorkItemSearchRequest, WorkItemSearchResponse } from "Search/LegacyWebApi/Contracts/WorkItem";

export class SearchStore extends BaseSearchStore.SearchStore<WorkItemSearchRequest, WorkItemSearchResponse, WorkItemResult> {
    constructor(changedEventName: string, data?: ISeedData<WorkItemResult>) {
        super(changedEventName);
        if (data && data.responseWithActivityId) {
            const responseWithActivityId = data.responseWithActivityId;
            const response = responseWithActivityId.response as WorkItemSearchResponse;
            this._state = {
                query: response.query,
                response: response,
                searchStatus: BaseSearchStore.SearchStatus.Success,
                activityId: responseWithActivityId.activityId && responseWithActivityId.activityId[0],
                source: data.source
            };
        } else if (data && data.error) {
            this._state = {
                query: data.error.query,
                response: undefined,
                searchStatus: BaseSearchStore.SearchStatus.Failed,
                activityId: data.error.activityId,
                source: data.source,
                error: data.error.error
            }
        }
    }

    public isEmptyResponse = (): boolean => {
        return this._state?.response?.results?.count === 0;
    }

    public areCorrectResultsLoaded = (query: WorkItemSearchRequest, response: WorkItemSearchResponse): boolean => {
        query.takeResults = response.query.takeResults;
        return Utils.areQueriesEqual(query, response.query);
    }

    public areQueriesSame = (queryInState: WorkItemSearchRequest, queryInPayload: WorkItemSearchRequest): boolean => {
        return Utils.areQueriesEqual(queryInState, queryInPayload);
    }

    public updateItemsOnSort = (payload: ISortOptionChangedPayload<WorkItemResult>): void => {
        if (this._state.response) {
            this._state.response.results.values = payload.sortedItems;
            this.emitChanged();
        }
    }

    public getUpdatedResponse = (responseInPayload: WorkItemSearchResponse): WorkItemSearchResponse => {
        const { response, fetchMoreScenario } = this._state;
        if (!fetchMoreScenario || !response) {
            return responseInPayload;
        }

        response.results.values.push(...responseInPayload.results.values);
        return response;
    }
}
